import { Pipe, PipeTransform } from '@angular/core';
import {DateUtils} from '@shared/utils/date-utils.class';

@Pipe({
  name: 'endOfMonth'
})
export class EndOfMonthPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    if (value)
    return DateUtils.convertYYYYMMtoEndDate(String(value));
    return value
  }

}
